import {useState, memo, useMemo} from 'react';
import { Routes, Route, useLocation } from "react-router-dom";
import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import { locals } from './utils/index'
import Index from './view/index/index'
import Bindroom from './view/bindroom/index'
import Charge from './view/charge/index'
import Consumptionflow from './view/consumptionflow/index'
import Login from './view/login/index'
import Paymenthistory from './view/paymenthistory/index'
import Seting from './view/seting/index'
import Instructions from './view/Instructions/index'
import {CSSTransition, TransitionGroup } from 'react-transition-group'
import './App.css';
// 使用 NProgress
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'; 
/**
 * @description 设置国际化
 */
i18n
  .use(initReactI18next)
  .init({
    // 设置语言资源，可以根据需要引入其他语言文件
    resources: {
      en: {
        translation: {
          // 将所有需要国际化的文本放在这里
          // 例如："hello": "Hello",
          ...locals.en
        },
      },
      zh: {
        translation: {
          // 中文翻译
          // 例如："hello": "你好",
          ...locals.zh
        },
      },
    },
    lng:  'zh',//language as languageType, // 默认语言
    fallbackLng: 'zh', // 如果当前语言没有对应的翻译，将使用该语言作为备用
    interpolation: {
      escapeValue: false, // 不要对翻译的文本进行转义，以支持 HTML 标签
    },
  });
//全局进度条的配置
NProgress.configure({ 
  easing: 'ease',  // 动画方式    
  speed: 1000,  // 递增进度条的速度    
  showSpinner: false, // 是否显示加载ico    
})
function App() {
  const useLocationWrapper = () => useLocation()
  const location = useLocationWrapper()
  const [isPending, setIsPending] = useState(false)
  const onEnter = () => setIsPending(true)
  const onEntered = () => setIsPending(false)
  
  // 使用 NProgress
  NProgress.start();
  useMemo(() => {
    NProgress.done();
  },[location])
  return (
   <div className='App'>
{/*      <TransitionGroup className="transition-group">
     <CSSTransition
          key={location.key}
          timeout={{ enter: 500, exit: 500 }}
          classNames="fade"
          onEnter={onEnter}
          onEntered={onEntered}
        > */}
<div /* className="router-section" */>
    <Routes location={location}>
        <Route path="/" element={<Index />}  />
        <Route path="/bindroom" element={<Bindroom />} />
        <Route path="/charge" element={<Charge />} />
        <Route path="/consumptionflow" element={<Consumptionflow />} />
        <Route path="/paymenthistory" element={<Paymenthistory />} />
        <Route path="/seting" element={<Seting />} />
        <Route path="/instructions" element={<Instructions />} />
        <Route path="/login" element={<Login />} />
      </Routes>
      </div>
 {/*    </CSSTransition>
    </TransitionGroup> */}
       </div>
  );
}
export default memo(App)
